import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import * as globals from '../globals';

@Injectable()
export class UploadService {
  progress$: any;
  progress: any;
  progressObserver: any;
  private bucketname = globals.BUCKETNAME;

  constructor() {
    this.progress$ = Observable.create(observer => {
      this.progressObserver = observer;
    }).share();
  }


  makeFileRequest(url: string,
    params: Array<string>,
    files: Array<File>,
    projectid: string,
    breadCrumbStringPath: string,
    tenantid: String,
    planid: string,
    policy: string,
    signature: string,
    serverdate: string) {
    return new Promise((resolve, reject) => {
      let formData: any = new FormData();
      let xhr = new XMLHttpRequest();

      let uploadFileID = params[1];
      let filename = files[params[1]].name;
      let progressCount = params[2];

      console.log('inside makeFileRequest');
      console.log(' params : ', params, ' Param[0] : ', params[0], ' Params[1] : ', params[1]);

      // Date stuff
      /*var datePipe = new DatePipe();
      let todayYMD = datePipe.transform(new Date(), 'yyyyMMdd');
      let todayISO = todayYMD + 'T000000Z';*/
      let todayYMD = serverdate;
      let todayISO = serverdate + 'T000000Z';

      console.log('=>todayISO:', todayISO);
      console.log('=>todayYMD:', todayYMD);
      console.log('=>signature:', signature);
      console.log('=>policy:', policy);
      if (params[0]) {
        console.log('=>key:', this.bucketname + '/' + tenantid + '/' + projectid + '/Attachments/' + params[0]);
      } else {
        console.log('=>key:', this.bucketname + '/' + tenantid + '/' + projectid + '/Attachments/' + files[0].name);
      }
      // console.log(" Current breadCrumbKeyString : ", this._ProjectsInfoService.getCurrentBredcrumbPath());

      formData.append('acl', 'public-read');
      formData.append('Content-Type', 'application/octet-stream');
      formData.append('X-Amz-Date', todayISO);
      formData.append('x-amz-server-side-encryption', 'AES256');
      formData.append('x-amz-meta-uuid', '14365123651274');
      formData.append('X-Amz-Algorithm', 'AWS4-HMAC-SHA256');

      console.log('PLANID:', planid);

      if (planid === '3') {
        formData.append('X-Amz-Credential', 'AKIALRY7TZ3GLH7GMHOQ/' + todayYMD + '/us-gov-west-1/s3/aws4_request');
      } else {
        // LEAVE us-west-2 HARDCODED.  The server has this hardcoded to match, and S3 is region-free...
        formData.append('X-Amz-Credential', 'AKIAIOFP5KTDKSWJUH3Q/' + todayYMD + '/us-west-2/s3/aws4_request');
      }

      formData.append('X-Amz-Signature', signature);
      formData.append('Policy', policy);

      if (breadCrumbStringPath) {
        if (params[0]) {
          formData.append('key', breadCrumbStringPath + '/' + params[0]);
        } else {
          formData.append('key', breadCrumbStringPath + '/' + files[params[1]].name);
        }
      } else {
        if (params[0]) {
          formData.append('key', this.bucketname + '/' + tenantid + '/' + projectid + '/Attachments/' + params[0]);
        } else {
          formData.append('key', this.bucketname + '/' + tenantid + '/' + projectid + '/Attachments/' + files[params[1]].name);
        }
      }

      formData.append('file', files[params[1]]);

      console.log('Form data appended');
      // this.progresses[0].currentValue = 10;
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          console.log(event.loaded);
          let progressValue = event.loaded / event.total * 100;
          this.progress = Math.round(event.loaded / event.total * 100);

          this.progressObserver.next(this.progress + '~' + progressCount + '~' + filename);
        }
      };

      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
            //   this.progresses[0].currentValue = 100;
          } else if (xhr.status == 204) {
            resolve(true);
            //   this.progresses[0].currentValue = 100;
          } else {
            reject(xhr.response);
          }
        }
      };
      xhr.open('POST', url, true);
      xhr.send(formData);
    });
  }


  makeProjectUploadRequest(url: string,
    params: Array<string>,
    files: Array<File>,
    tenantid: String,
    planid: string,
    modelBool: boolean,
    projectid: string,
    policy: string,
    signature: string,
    serverdate: string) {
    return new Promise((resolve, reject) => {
      let formData: any = new FormData();
      let xhr = new XMLHttpRequest();

      console.log('inside makeProjectUploadRequest');

      // var uploadFileID = params[1];
      // var filename = files[params[1]].name;
      // Date stuff
      /*var datePipe = new DatePipe();
      let todayYMD = datePipe.transform(new Date(), 'yyyyMMdd');
      let todayISO = todayYMD + 'T000000Z';*/
      let todayYMD = serverdate;
      let todayISO = serverdate + 'T000000Z';

      console.log('=>todayISO:', todayISO);
      console.log('=>todayYMD:', todayYMD);
      console.log('=>signature:', signature);
      console.log('=>policy:', policy);
      // if(modelBool)
      //   console.log('=>key:', this.bucketname +'/' + tenantid + '/Models/' + projectid + '/' + files[0].name);
      // else
      console.log('=>key:', this.bucketname + '/' + tenantid + '/' + projectid + '/' + files[0].name);

      formData.append('acl', 'public-read');
      formData.append('Content-Type', 'application/octet-stream');
      formData.append('X-Amz-Date', todayISO);
      formData.append('x-amz-server-side-encryption', 'AES256');
      formData.append('x-amz-meta-uuid', '14365123651274');
      formData.append('X-Amz-Algorithm', 'AWS4-HMAC-SHA256');
      if (planid === '3') {
        formData.append('X-Amz-Credential', 'AKIALRY7TZ3GLH7GMHOQ/' + todayYMD + '/us-gov-west-1/s3/aws4_request');
      } else {
        // LEAVE us-west-2 HARDCODED.  The client has this hardcoded to match, and S3 is region-free...
        formData.append('X-Amz-Credential', 'AKIAIOFP5KTDKSWJUH3Q/' + todayYMD + '/us-west-2/s3/aws4_request');
      }

      formData.append('X-Amz-Signature', signature);
      formData.append('Policy', policy);
      // if(modelBool)
      //   formData.append('key', this.bucketname + '/' + tenantid + '/Models/' + projectid + '/' + files[0].name);
      // else
      formData.append('key', this.bucketname + '/' + tenantid + '/' + projectid + '/' + files[0].name);

      formData.append('file', files[0]);

      console.log('Form data appended');

      // this.progresses[0].currentValue = 10;
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          console.log(event.loaded);
          let progressValue = event.loaded / event.total * 100;
          this.progress = Math.round(event.loaded / event.total * 100);
          this.progressObserver.next(this.progress);
          // this.progressObserver.next(this.progress +"~"+ uploadFileID + "~" + filename);
        }
      };

      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else if (xhr.status == 204) {
            resolve(true);
          } else {
            reject(xhr.response);
          }
        }
      };
      xhr.open('POST', url, true);
      xhr.send(formData);
    });
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/upload.service.ts